import Vue from "vue";
import Vuetify from "vuetify/lib";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#008BBF",
        buttons: "#008bbf",
        secondary: "#5170b5",
        card: "#EEEEEE",
        "progress-bar": "#FEC101",
        "progress-bar-completed": "#048708",
        footer: "#008BBF",
        "navigation-drawer": "#EEEEEE",
        accent: "#ffc103",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
      dark: {
        primary: "#f06a25",
        secondary: "#5170b5",
        accent: "#f06a25",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
  icons: {
    iconfont: "fa",
  },
});
